import { render, staticRenderFns } from "./TraxAccountEntityCrud.vue?vue&type=template&id=283c5920"
import script from "./TraxAccountEntityCrud.vue?vue&type=script&lang=js"
export * from "./TraxAccountEntityCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports